import { defaultTo } from 'lodash';

import { selectActivePlacingType, selectPublicationPeriod, selectActivePackage } from '../publishTerms';
import { EPlacingType } from '../../redux/reducers';

import { IAppState } from '../../redux';

export const selectDefaultRecommendedPackagePublicationPrice = (state: IAppState): number => {
  const activePlacingType = selectActivePlacingType(state);
  const publicationPeriod = selectPublicationPeriod(state);
  const activePackage = selectActivePackage(state);

  const { price: publicationPrice = 0, isPaid } = publicationPeriod || {};
  const { price: packagePrice = 0 } = activePackage || {};

  if (activePlacingType === EPlacingType.package) {
    return packagePrice;
  }

  // Объявление редактируется и пользователь платил деньги за публикацию (в некоторых регионах публикация бесплатна)
  const isFreePublicationPrice = isPaid && publicationPrice;

  return isFreePublicationPrice ? 0 : defaultTo(publicationPrice, 0);
};
